module.exports = __webpack_public_path__ + "80f82b14a704cab6e7f808ad0b468cc2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-girl-brown-s.png
// module id = 2686
// module chunks = 0